import type WhiteboardController from '../../controllers/WhiteboardController';
import type {
  HierarchyImportRelationshipType,
  RecordReference,
} from '../../types';
import type Shape from '../../objects/Shape';
import type ShapeRecord from '../../shapes/ShapeRecord';

// Configuration constants moved from scattered locations
export const ImportConfig = {
  MAX_RECORDS: 1000,
  DIAGRAM_HINTS: {
    widthHint: 2000,
    heightHint: 1000,
  },
  DEFAULT_FONT_SIZE: 14,
} as const;

// Main props object for hierarchy import
export interface HierarchyImportProps {
  controller: WhiteboardController;
  selection: Shape<ShapeRecord> & RecordReference;
  relationshipType: HierarchyImportRelationshipType;
}
// Simple error class with structured data
export class HierarchyImportError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly cause?: Error
  ) {
    super(message);
    this.name = 'HierarchyImportError';
  }

  static validation(message: string): HierarchyImportError {
    return new HierarchyImportError('VALIDATION_ERROR', message);
  }

  static network(cause: Error): HierarchyImportError {
    return new HierarchyImportError(
      'NETWORK_ERROR',
      'Failed to fetch hierarchy data',
      cause
    );
  }

  static layout(message: string): HierarchyImportError {
    return new HierarchyImportError('LAYOUT_ERROR', message);
  }
}

// Position calculation result
export interface PositionOffset {
  x: number;
  y: number;
}
